import React from 'react';
import { Shop } from '../App';
interface ShopCardProps {
  shop: Shop;
  onReadingChange: (value: number) => void;
}
export const ShopCard: React.FC<ShopCardProps> = ({
  shop,
  onReadingChange
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseFloat(e.target.value) || 0;
    onReadingChange(value);
  };
  const calculateUsage = () => {
    return Math.max(0, shop.currentReading - shop.previousReading);
  };
  return <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200" data-id="element-198">
      <div className="flex justify-between items-center mb-3" data-id="element-199">
        <h3 className="font-medium text-gray-800" data-id="element-200">{shop.name}</h3>
        <span className="text-sm text-gray-500" data-id="element-201">
          Previous: {shop.previousReading}
        </span>
      </div>
      <div className="flex items-center space-x-3" data-id="element-202">
        <div className="flex-1" data-id="element-203">
          <label htmlFor={`reading-${shop.id}`} className="block text-sm text-gray-600 mb-1" data-id="element-204">
            Current Reading
          </label>
          <input id={`reading-${shop.id}`} type="number" value={shop.currentReading || ''} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-205" />
        </div>
        <div className="w-20 text-center" data-id="element-206">
          <div className="text-sm text-gray-600 mb-1" data-id="element-207">Usage</div>
          <div className="font-semibold text-blue-600" data-id="element-208">{calculateUsage()}</div>
        </div>
      </div>
    </div>;
};